import React from 'react';
import Form from 'react-bootstrap/Form'
import InputGroup from "react-bootstrap/InputGroup"
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import InputMask from "react-input-mask";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome/index";
import jwtClient from '../../JwtClient'
import FormDelimiter from "../FormDelimiter";
import {phoneTemplate} from './PackageFormUA';


export class Consignee extends React.Component {
    state = {disabled: true};

    render() {
        const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            setFieldValue,
        } = this.props;
        return (
            <div>
                <FormDelimiter text="CONSIGNEE"/>
                <Form.Group>
                    <Row>
                        <Col sm="3">
                            <InputGroup>
                                <InputGroup.Prepend>
                                    <InputGroup.Text>
                                        <FontAwesomeIcon icon="phone"/>
                                    </InputGroup.Text>
                                </InputGroup.Prepend>
                                <InputMask
                                    className={this.getMarkedInputClass(touched.phone, !!errors.phone)}
                                    name="phone"
                                    value={values.phone}
                                    // TODO refactor into separate method
                                    onChange={e => {
                                        handleChange(e);
                                        const phone = e.target.value;
                                        // TODO
                                        // Client sends around 8 requests in case of 404 response
                                        if (phoneTemplate.test(phone)) {
                                            jwtClient.get(`/api/v1/consignee/phone/${phone}`)
                                                .then(response => {
                                                    setFieldValue('name', response.data.name);
                                                    setFieldValue('surname', response.data.surname);
                                                    setFieldValue('email', response.data.email);
                                                    setFieldValue('consigneeId', response.data.id);
                                                    this.setState({disabled: false});
                                                })
                                                .catch(error => {
                                                    if (error.response && error.response.status === 404) {
                                                        setFieldValue('name', '');
                                                        setFieldValue('surname', '');
                                                        setFieldValue('email', '');
                                                        setFieldValue('consigneeId', '');
                                                        this.setState({disabled: false});
                                                    } else if (error.request) {
                                                        this.props.showError('The service is temporary unavailable! Contact the administrators to resolve the issue!')
                                                    }
                                                });
                                        }
                                    }}
                                    onBlur={handleBlur}
                                    mask="\+380 99 999-99-99"
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.phone}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Col>
                        <Col sm="3">
                            <InputGroup>
                                <InputGroup.Prepend>
                                    <InputGroup.Text>
                                        <small>Name</small>
                                    </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                    disabled={this.state.disabled}
                                    name="name"
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.name && !!errors.name}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.name}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Col>
                        <Col sm="3">
                            <InputGroup>
                                <InputGroup.Prepend>
                                    <InputGroup.Text>
                                        <small>Surname</small>
                                    </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                    disabled={this.state.disabled}
                                    name="surname"
                                    value={values.surname}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.surname && !!errors.surname}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.surname}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Col>
                        <Col sm="3">
                            <InputGroup>
                                <InputGroup.Prepend>
                                    <InputGroup.Text>
                                        <FontAwesomeIcon icon="at"/>
                                    </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                    disabled={this.state.disabled}
                                    type="email"
                                    name="email"
                                    value={values.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.email && !!errors.email}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.email}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Col>
                    </Row>
                </Form.Group>
            </div>
        )
    }

    getMarkedInputClass = (isTouched, hasError) => {
        if (isTouched && hasError) {
            return 'form-control is-invalid'
        } else {
            return 'form-control'
        }

    };
}
